import type { idTextPair, labelValuePair } from "./Types";

export class Helper {

    public static getRange(start: number, end: number, increments: number = 1) {
        return Array.from({ length: (end - start) / increments + 1 }, (_, k) => start + k * increments);
    }

    public static ToLabelValuePair(options: string[] | number[]) {
        let target: labelValuePair[] = [];
        options.forEach((value) => {
            target.push({ label: value, value: value });
        });
        return target;
    }

    public static ToIdTextPair(options: string[] | number[]) {
        let target: idTextPair[] = [];
        options.forEach((value) => {
            target.push({ id: value, text: value });
        });
        return target;
    }

}